// @ts-nocheck
// Greif UI Kit = line-truck
import * as React from "react";

const Truck: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M7.833 17.2c0-.663-.56-1.2-1.25-1.2s-1.25.537-1.25 1.2.56 1.2 1.25 1.2 1.25-.537 1.25-1.2m10.834 0c0-.663-.56-1.2-1.25-1.2s-1.25.537-1.25 1.2.56 1.2 1.25 1.2 1.25-.537 1.25-1.2m-2.5-2.8h4.166v-2.869L18.322 9.6h-2.155zm-12.5 0H14.5V5.6H3.667zm16.666 2.8c0 1.546-1.305 2.8-2.916 2.8S14.5 18.746 14.5 17.2c0-.43.1-.836.28-1.2H9.22c.18.364.28.77.28 1.2 0 1.546-1.306 2.8-2.917 2.8s-2.916-1.254-2.916-2.8c0-.43.1-.836.28-1.2H2.833c-.46 0-.833-.358-.833-.8V4.8c0-.442.373-.8.833-.8h12.5c.46 0 .834.358.834.8V8h2.5c.22 0 .433.084.589.234l2.5 2.4c.156.15.244.354.244.566v4c0 .442-.373.8-.833.8h-1.114c.18.364.28.77.28 1.2"
            />
        </svg>
    );
};

export default React.memo(Truck);
